<template>
  <b-tooltip
    :active="errors.length !== 0"
    :label="errorLabel"
    type="is-warning"
    position="is-left"
  >
    <button
      :disabled="disabled || errors.length !== 0"
      class="button-outline button is-color2 color2"
      data-action-type="EXPORT:ITINERARY_PREVIEW"
      @click="exportPreview"
    >
      <i class="mr-4"><IconExport class="icon is-small" /></i>
      {{ canEditWeblink || !hasLinkCode ? "Preview" : "Open Weblink" }}
    </button>
  </b-tooltip>
</template>

<script>
import IconExport from "@/components/icons/IconExport.vue";
import { mapGetters } from "vuex";

export default {
  name: "ExportToWeblinkButton",
  components: { IconExport },
  props: {
    disabled: Boolean,
    canEditWeblink: Boolean,
    hasLinkCode: Boolean,
    exportPreview: Function,
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
    }),
    errors() {
      const errors = [];
      if (!this.itinerary?.data?.link_code) {
        errors.push("The weblink settings have not yet been saved.");
      }
      return errors;
    },
    errorLabel() {
      if (this.errors.length === 0) return "";
      return this.errors[0];
    },
  },
};
</script>
